import { useMaskConfig } from '../../../hooks/mask-context';
import { OverlayController } from '../../../overlay-controller/OverlayController';
import { useMaskOverlay } from '../../../overlay-controller/use-mask-overlay';
import { MaskControllerProps } from '../../../types';
import {
  useWebShopMaskOverlayRequest,
  useWebShopSubmitHandler,
} from '../hooks';
import { WebShopMaskFormValue } from '../types';

import { WebShopOverlayControllerAccessData } from './WebShopOverlayControllerAccessData';
import { WebShopOverlayControllerGeneralData } from './WebShopOverlayControllerGeneralData';

const NEW_ENTITY_DATA = {};

export const WebShopOverlayController = (props: MaskControllerProps) => {
  const mask = useMaskConfig(props);
  const request = useWebShopMaskOverlayRequest(mask.id);
  const overlay = useMaskOverlay<WebShopMaskFormValue>({
    ...props,
    request,
    newEntityData: NEW_ENTITY_DATA,
    mask,
    getSubTitle: (webShop) => webShop.name,
  });

  const onSubmit = useWebShopSubmitHandler({
    isCreateMode: mask.isCreateMode,
    dirtyFields: overlay.form.formState.dirtyFields,
    onAfterSave: props.onAfterSave,
  });

  return (
    <OverlayController<WebShopMaskFormValue> {...overlay} onSubmit={onSubmit}>
      <WebShopOverlayControllerGeneralData />
      <WebShopOverlayControllerAccessData />
    </OverlayController>
  );
};
